import yaml from 'js-yaml'
import axios from 'axios'
import JSZip from 'jszip'
import { DEFAULTSERVOVALUES } from '../Components/Code/CreateAction/defaultData'
import { generateDeviceDataKey } from '../Components/ReusableComponents/ByteTransfer/utils'

const GITHUB_TOKEN =
    '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'
const GITHUB_API = 'https://api.github.com'
const REPO_OWNER = 'YuduRobotics'
const REPO_NAME = 'plode-release-management'
const BRANCH = 'asset-management'

const eachActionServoObj = (MSB, LSB) => {
    return {
        isEnabled: false,
        value: (MSB << 8) | LSB,
    }
}
const bytesToActions = (actionGroupBytes) => {
    try {
        let index = 0
        let totalTime = 0

        // Validate header
        // if (
        //     actionGroupBytes[index++] !== 'G'.charCodeAt(0) ||
        //     actionGroupBytes[index++] !== 'R'.charCodeAt(0)
        // ) {
        //     throw new Error('Invalid byte sequence: Missing header (GR)')
        // }

        // Extract file name length and file name
        // let fileNameLength = actionGroupBytes[index++]
        // let fileName = String.fromCharCode(
        //     ...actionGroupBytes.slice(index, index + fileNameLength)
        // )
        // index += fileNameLength

        // Extract number of actions (MSB, LSB)
        let actionCount =
            (actionGroupBytes[index] << 8) | actionGroupBytes[index + 1]
        index += 2

        let actionsData = {
            commonActionState: {},
            allActions: [],
            projectName: '',
        }

        // Initialize commonActionState
        const connectedDevice = sessionStorage.getItem('connectedDevice') || ''
        const actionKeys = Array.from(
            { length: connectedDevice === 'Hexapod' ? 18 : 16 },
            (_, i) => (i + 1).toString()
        )

        if (connectedDevice === 'Humanoid') {
            actionKeys.push('H')
        }
        actionKeys.unshift('T')

        actionKeys.forEach((key) => {
            actionsData.commonActionState[key] = { isSelected: false }
        })
        actionsData.commonActionState['T'].isSelected = true // Assuming "T" is always selected

        // Loop through each action
        for (let i = 0; i < actionCount; i++) {
            let action = {
                id: `region-${Math.random().toString(36).substr(2, 10)}`, // Generating a random ID
                data: {},
                markerPositionTime: (Math.random() * 1).toFixed(3), // Dummy time
                actionName: `Action ${i + 1}`,
            }

            // Read servo values for each key
            actionKeys.forEach((key) => {
                if (key !== 'H') {
                    let MSB = actionGroupBytes[index++]
                    let LSB = actionGroupBytes[index++]
                    let value = (MSB << 8) | LSB
                    action.data[key] = {
                        isEnabled: false,
                        value,
                    }
                    if (key === 'T') {
                        totalTime = totalTime + (JSON.parse(value) || value)
                        action.markerPositionTime = totalTime / 1000
                    }
                } else {
                    action.data[key] = {
                        isEnabled: false,
                        value: actionGroupBytes[index++],
                    }
                }
            })

            actionsData.allActions.push(action)
        }

        const defaultServoValue =
            DEFAULTSERVOVALUES[
                generateDeviceDataKey(
                    connectedDevice,
                    sessionStorage.getItem('deviceVersion') || '0.0.0'
                )
            ] || {}
        actionsData.allActions.forEach((action) => {
            actionKeys.forEach((key) => {
                const isChanged =
                    defaultServoValue[key] !== action.data[key].value
                action.data[key].isEnabled = isChanged
                if (isChanged) {
                    actionsData.commonActionState[key].isSelected = true
                }
            })
        })

        // extract the action details array
        let actionDetails = null
        if (
            actionGroupBytes[index++] == 'E'.charCodeAt(0) ||
            actionGroupBytes[index++] == 'R'.charCodeAt(0)
        ) {
            actionDetails = String.fromCharCode(
                ...actionGroupBytes.slice(index + 1)
            )
            actionDetails = JSON.parse(actionDetails)
        }

        //add the action name in actionsData object
        actionsData.allActions.map((action, ind) => {
            if (actionDetails?.actionDetails?.[ind]?.actionName) {
                action.actionName =
                    actionDetails?.actionDetails?.[ind]?.actionName
            }
        })
        actionsData.projectName = actionDetails?.projectName || ''
        return { newActionsData: actionsData, actionDetails }
    } catch (error) {
        console.error('Error parsing actionGroupBytes:', error)
        return {}
    }
}

//calculate the waiting time
const calculateWaitTime = (fileSize) => {
    //we assume the write speed is 3mbps
    let writeSpeed = (3 * 10) ^ 6
    let waitTime = ((fileSize * 8) / writeSpeed) * 1000
    return waitTime + 5000
}

//convert the all files in a directory response to a array where present only the file name
const convertFileArrFormat = (listResponse) => {
    const files = listResponse?.files || []

    const result = {
        fileArray: [],
        mp3FileArray: [],
    }

    files.forEach((file) => {
        if (!file?.is_file || !file?.filename) return

        if (file.filetype === 'bin') {
            result.fileArray.push(file.filename.replace(/\.bin$/i, ''))
        } else if (file.filetype === 'mp3') {
            result.mp3FileArray.push(file.filename.replace(/\.mp3$/i, ''))
        }
    })

    return result
}

// get the list of action file present in zing , and check same file present or not
//also remove the audio file if saving time user did not put any mp3 file
const checkFileExist = async ({
    socket,
    filePath,
    filename,
    isAudioFilePresent,
}) => {
    try {
        //get the Lists all files in a directory on the mounted USB device.
        let listResponse = await getListFile({
            socket,
            filePath: filePath,
        })

        let nameArray = { fileArray: [], mp3FileArray: [] }

        if (listResponse.success) {
            nameArray = convertFileArrFormat(listResponse)
        } else {
            if (
                listResponse.error.includes(
                    'Error listing files: Error reading directory: /Volumes/NO NAME/ZING/actions/user'
                )
            ) {
                return { fileArray: [], mp3FileArray: [] }
            } else {
                throw new Error('Action does not save')
            }
        }

        if (nameArray.fileArray.includes(filename)) {
            const result = window.confirm(
                'A file with the same name already exists. Are you sure you want to replace it?'
            )
            if (result === false) {
                return false
            }
        }

        if (!isAudioFilePresent && nameArray.mp3FileArray.includes(filename)) {
            let removeResponse = await removeFile({
                socket,
                filePath: filePath + '/' + filename + '.mp3',
            })
        }
        return true
    } catch (e) {
        console.log('ERROR', e)
        throw new Error('Action does not save')
    }
}

//get the device mount point
const getMountPoint = ({ socket }) => {
    return new Promise((resolve, reject) => {
        socket.emit('list-mount', (response) => {
            if (response.success) {
                resolve(response.output)
            } else {
                reject(new Error(response.error))
            }
        })

        // Optional: add a timeout to reject the promise if no response is received
        setTimeout(() => {
            reject(new Error('Timeout while waiting for list-mount response'))
        }, 10000) // 10 seconds timeout
    })
}

//Lists all files in a directory on the mounted USB device
const getListFile = ({ socket, filePath }) => {
    return new Promise((resolve, reject) => {
        console.log({ socket, filePath })
        socket.emit('list-files', { file_path: filePath }, (response) => {
            resolve(response)
        })

        // Optional: add a timeout to reject the promise if no response is received
        setTimeout(() => {
            reject(new Error('Timeout while waiting for list-files response'))
        }, 60000) // 60 seconds timeout
    })
}

//Writes a file to the USB device
const writeFile = ({
    socket,
    fileName,
    fileFormat,
    filePath,
    fileData,
    writeTime,
}) => {
    console.log({ fileName, fileFormat, filePath, writeTime })
    return new Promise((resolve, reject) => {
        socket.emit(
            'add-file',
            {
                name: fileName,
                format: fileFormat,
                path: filePath,
                data: fileData,
            },
            (response) => {
                resolve(response)
            }
        )

        // Optional: add a timeout to reject the promise if no response is received
        setTimeout(() => {
            reject(new Error('Timeout while waiting for add-file response'))
        }, writeTime)
    })
}

//Removes a file from the USB device
const removeFile = ({ socket, filePath }) => {
    return new Promise((resolve, reject) => {
        socket.emit('remove-file', { file_path: filePath }, (response) => {
            resolve(response)
        })

        // Optional: add a timeout to reject the promise if no response is received
        setTimeout(() => {
            reject(new Error('Timeout while waiting for remove-file response'))
        }, 60000) // 60 seconds timeout
    })
}

//Removes a directory from the USB device
const removeDirectory = ({ socket, dirPath }) => {
    return new Promise((resolve, reject) => {
        socket.emit('remove-dir', { dir_path: dirPath }, (response) => {
            resolve(response)
        })

        setTimeout(() => {
            reject(new Error('Timeout while waiting for remove-dir response'))
        }, 60000) // 60 seconds timeout
    })
}

//Reads a file from the USB device and returns its contents as base64 encoded data.
const readsFile = ({ socket, filePath }) => {
    return new Promise((resolve, reject) => {
        socket.emit('read-file', { file_path: filePath }, (response) => {
            resolve(response)
        })

        // Optional: add a timeout to reject the promise if no response is received
        setTimeout(() => {
            reject(new Error('Timeout while waiting for read-file response'))
        }, 120000) // 60 seconds timeout
    })
}

// Fetch file from GitHub using Contents API with auth token
const fetchGitHubFile = async (folderTag, filename) => {
    try {
        const url = `${GITHUB_API}/repos/${REPO_OWNER}/${REPO_NAME}/contents/${folderTag}/${filename}?ref=${BRANCH}`
        console.log('Fetching from GitHub API:', url)

        const response = await axios.get(url, {
            headers: {
                Accept: 'application/vnd.github+json',
                Authorization: `Bearer ${GITHUB_TOKEN}`,
                'X-GitHub-Api-Version': '2022-11-28',
            },
            timeout: 30000,
        })

        // Decode base64 content
        const content = atob(response.data.content)
        console.log('File fetched successfully, size:', content.length, 'bytes')
        return content
    } catch (error) {
        console.error('GitHub API fetch failed:', error.message)
        throw error
    }
}

// Download ZIP file from Google Cloud Storage URL
const downloadZipFile = async (gcsUrl, onProgress = null) => {
    try {
        console.log('Downloading ZIP from Google Cloud Storage:', gcsUrl)

        // Download directly from GCS (no CORS issues)
        const response = await axios.get(gcsUrl, {
            responseType: 'arraybuffer',
            timeout: 180000, // 3 minutes for large files
            onDownloadProgress: (progressEvent) => {
                if (onProgress && progressEvent.total) {
                    const percentCompleted = Math.round(
                        (progressEvent.loaded * 100) / progressEvent.total
                    )
                    onProgress({
                        type: 'download',
                        percent: percentCompleted,
                        loaded: progressEvent.loaded,
                        total: progressEvent.total,
                    })
                }
            },
        })

        console.log('ZIP downloaded, size:', response.data.byteLength, 'bytes')
        return response.data
    } catch (error) {
        console.error('ZIP download failed:', error.message)
        throw error
    }
}

// Parse YAML content to JavaScript object
const parseYaml = (yamlContent) => {
    try {
        return yaml.load(yamlContent)
    } catch (error) {
        console.error('Error parsing YAML:', error)
        throw error
    }
}

// Compare version strings (e.g., "1.0" vs "1.1")
const compareVersions = (version1, version2) => {
    // Convert versions to numbers for comparison
    const v1 = parseFloat(version1)
    const v2 = parseFloat(version2)

    if (v1 > v2) return 1
    if (v1 < v2) return -1
    return 0
}

// Check and update firmware if needed
const checkAndUpdateMetaYaml = async ({
    socket,
    folderTag,
    deviceFolder = 'zing',
    onProgress = null,
    checkOnly = false,
}) => {
    try {
        let mountPoint
        try {
            mountPoint = await getMountPoint({ socket })
        } catch (mountError) {
            if (checkOnly)
                return {
                    success: true,
                    updateAvailable: false,
                    mountFound: false,
                }
            console.warn('Mount point check failed:', mountError.message)
            if (onProgress) {
                onProgress({
                    stage: 'complete',
                    message:
                        'Firmware updated (Asset update skipped - No Mount)',
                    percent: 100,
                })
            }
            return {
                success: true,
                updated: false,
                skipped: true,
                reason: 'Mount point not found',
            }
        }

        if (checkOnly)
            console.log('Mount point found during check:', mountPoint)
        else console.log('Mount point:', mountPoint)
        const devicePath = `${mountPoint}/${deviceFolder}`
        const metaYamlPath = `${devicePath}/meta.yaml`

        // Step 1: Fetch meta.yaml from GitHub based on device firmware folder tag
        if (!checkOnly)
            console.log('Fetching meta.yaml from GitHub for folder:', folderTag)
        if (onProgress && !checkOnly)
            onProgress({
                stage: 'checking',
                message: 'Checking for updates...',
            })
        const newYamlContent = await fetchGitHubFile(folderTag, 'meta.yaml')
        const newYaml = parseYaml(newYamlContent)
        console.log(
            'GitHub version:',
            newYaml.version,
            'Folder:',
            newYaml.folder
        )

        // Step 2: Check existing meta.yaml on device
        const existingFileResponse = await readsFile({
            socket,
            filePath: metaYamlPath,
        })

        let shouldUpdate = false
        if (!existingFileResponse.success) {
            console.log('No meta.yaml on device - full update needed')
            shouldUpdate = true
        } else {
            const base64Data = existingFileResponse.output
            const yamlContent = atob(base64Data)
            const existingYaml = parseYaml(yamlContent)

            if (!checkOnly) {
                console.log(
                    'Existing version:',
                    existingYaml.version,
                    'Folder:',
                    existingYaml.folder
                )
            }

            if (existingYaml.folder !== newYaml.folder) {
                console.log('Folder mismatch - update required')
                shouldUpdate = true
            } else {
                const versionComparison = compareVersions(
                    newYaml.version,
                    existingYaml.version
                )
                if (versionComparison > 0) {
                    console.log(
                        `New version available: ${newYaml.version} (Current: ${existingYaml.version})`
                    )
                    shouldUpdate = true
                } else {
                    console.log('Device is up to date')
                    shouldUpdate = false
                }
            }
        }

        if (checkOnly) {
            return {
                success: true,
                updateAvailable: shouldUpdate,
                mountFound: true,
                currentVersion: newYaml.version, // Return version info if needed
            }
        }

        if (!shouldUpdate) {
            if (onProgress)
                onProgress({
                    stage: 'complete',
                    message: 'Device is up to date',
                })
            return { success: true, updated: false, version: newYaml.version }
        }

        // Step 3: Download and extract ZIP using gcs_url from meta.yaml
        console.log('Downloading ZIP file...')
        if (onProgress)
            onProgress({
                stage: 'downloading',
                message: 'Downloading update...',
            })

        // Get the GCS URL from the meta.yaml
        const gcsUrl = newYaml.gcs_url
        if (!gcsUrl) {
            throw new Error('No gcs_url found in meta.yaml')
        }

        const zipBuffer = await downloadZipFile(gcsUrl, (progress) => {
            if (onProgress && progress.type === 'download') {
                onProgress({
                    stage: 'downloading',
                    message: `Downloading: ${progress.percent}%`,
                    percent: progress.percent,
                })
            }
        })

        if (onProgress)
            onProgress({ stage: 'extracting', message: 'Extracting files...' })
        const zip = new JSZip()
        const zipContent = await zip.loadAsync(zipBuffer)
        console.log('ZIP extracted')

        // Step 4: Clean up (except /user)
        console.log('Cleaning device folder...')
        if (onProgress)
            onProgress({ stage: 'cleaning', message: 'Cleaning old files...' })
        const listResponse = await getListFile({ socket, filePath: devicePath })
        if (listResponse.success) {
            for (const file of listResponse.files || []) {
                // Skip 'user' folder (case insensitive)
                if (file.filename.toLowerCase().includes('user')) {
                    continue
                }

                // Delete directories using remove-dir, files using remove-file
                if (file.is_file) {
                    await removeFile({
                        socket,
                        filePath: `${devicePath}/${file.filename}`,
                    })
                    console.log('Deleted file:', file.filename)
                } else {
                    await removeDirectory({
                        socket,
                        dirPath: `${devicePath}/${file.filename}`,
                    })
                    console.log('Deleted directory:', file.filename)
                }
            }
        } else {
            console.log(
                'Device folder does not exist yet, will be created with first file write'
            )
        }

        // Step 5: Upload all ZIP files
        console.log('Uploading new files...')
        if (onProgress)
            onProgress({ stage: 'uploading', message: 'Uploading files...' })

        const totalFiles = Object.values(zipContent.files).filter(
            (f) => !f.dir && f.name !== 'meta.yaml'
        ).length
        let count = 0

        for (const [filename, file] of Object.entries(zipContent.files)) {
            if (!file.dir && filename !== 'meta.yaml') {
                const content = await file.async('base64')

                // Parse the filename to extract path, name, and extension
                const lastSlashIndex = filename.lastIndexOf('/')
                const fileNameWithExt =
                    lastSlashIndex >= 0
                        ? filename.substring(lastSlashIndex + 1)
                        : filename
                const subdirectory =
                    lastSlashIndex >= 0
                        ? filename.substring(0, lastSlashIndex)
                        : ''

                const dotIndex = fileNameWithExt.lastIndexOf('.')
                const name =
                    dotIndex >= 0
                        ? fileNameWithExt.substring(0, dotIndex)
                        : fileNameWithExt
                const ext =
                    dotIndex >= 0 ? fileNameWithExt.substring(dotIndex + 1) : ''

                // Construct the full path including subdirectory with trailing slash
                const targetPath = subdirectory
                    ? `${devicePath}/${subdirectory}/`
                    : `${devicePath}/`

                await writeFile({
                    socket,
                    fileName: name,
                    fileFormat: ext,
                    filePath: targetPath,
                    fileData: content,
                    writeTime: 120000,
                })
                count++

                if (onProgress) {
                    const uploadPercent = Math.round((count / totalFiles) * 100)
                    onProgress({
                        stage: 'uploading',
                        message: `Uploading files: ${count}/${totalFiles}`,
                        percent: uploadPercent,
                    })
                }

                if (count % 5 === 0)
                    console.log(`Uploaded ${count}/${totalFiles} files...`)
            }
        }

        // Step 6: Save meta.yaml last
        console.log('Saving meta.yaml...')
        if (onProgress)
            onProgress({ stage: 'finalizing', message: 'Finalizing update...' })
        await writeFile({
            socket,
            fileName: 'meta',
            fileFormat: 'yaml',
            filePath: `${devicePath}/`,
            fileData: btoa(newYamlContent),
            writeTime: 120000,
        })

        console.log('Update complete!')
        if (onProgress)
            onProgress({ stage: 'complete', message: 'Update complete!' })
        return {
            success: true,
            updated: true,
            version: newYaml.version,
            filesUploaded: count,
        }
    } catch (error) {
        if (checkOnly) return { success: false, error: error.message }
        console.error('Update failed:', error)
        if (
            error.message &&
            (error.message.includes('Mount point') ||
                error.message.includes('list-mount'))
        ) {
            if (onProgress) {
                onProgress({
                    stage: 'complete', // Send COMPLETE, not ERROR
                    message: 'Firmware updated (Assets skipped)',
                })
            }
            return { success: true, skipped: true }
        }

        // Only send the ERROR stage if it is a REAL error (like network fail or write fail)
        if (onProgress)
            onProgress({
                stage: 'error',
                message: `Update failed: ${error.message}`,
            })
        return { success: false, error: error.message }
    }
}

export {
    bytesToActions,
    calculateWaitTime,
    convertFileArrFormat,
    getMountPoint,
    getListFile,
    writeFile,
    removeFile,
    readsFile,
    checkFileExist,
    fetchGitHubFile,
    downloadZipFile,
    parseYaml,
    compareVersions,
    checkAndUpdateMetaYaml,
}
